module.exports = __webpack_public_path__ + "img/brenton-pro.215245a7.jpg";